"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGeoPointToString = convertGeoPointToString;
const roundToDecimalPlaces_1 = require("../helpers/roundToDecimalPlaces");
function convertGeoPointToString(geoPoint, decimalPlaces) {
    const lat = (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(geoPoint.latitude, decimalPlaces).toFixed(decimalPlaces);
    const lon = (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(geoPoint.longitude, decimalPlaces).toFixed(decimalPlaces);
    return `${lat},${lon}`;
}
//# sourceMappingURL=convertGeoPointToString.js.map